export const CURRENT_STEP_NUMBER_TARGET = 'currentStepNumber';
export const STEPS_TARGET = 'steps';
export const STEPPER_VIEW = 'isStepperView';
